import { render, staticRenderFns } from "./DocumentPrint.vue?vue&type=template&id=51700559&scoped=true"
import script from "./DocumentPrint.vue?vue&type=script&lang=js"
export * from "./DocumentPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51700559",
  null
  
)

export default component.exports